import { privatePaths } from './paths/privatePaths';
import AdminUsersListPage from '@/features/admin-users/pages/AdminUsersListPage';
import CountriesPage from '@/features/countries/pages/CountriesPage';
import EndUsersPage from '@/features/end-users/pages/EndUsersPage';
import PlansPage from '@/features/plans/pages/PlansPage';
import ProfilePage from '@/features/profile/pages/ProfilePage';
import RegionsPage from '@/features/regions/pages/RegionsPage';
import SourcesPage from '@/features/sources/pages/SourcesPage';
import TenantDetailPage from '@/features/tenants/pages/TenantDetailPage';
import TenantsPage from '@/features/tenants/pages/TenantsPage';
import { Layout } from '@/shared/components/ahkinia/Layout/Layout';
import { PERMISSIONS } from '@/shared/constants/permissions';

const privateRoutes = [
  {
    path: privatePaths.ADMIN_USERS,
    component: <AdminUsersListPage />,
    layout: Layout,
    permissions: [PERMISSIONS.USERS_LIST],
    index: true,
  },
  {
    path: privatePaths.COUNTRIES,
    component: <CountriesPage />,
    layout: Layout,
    permissions: [PERMISSIONS.COUNTRIES_LIST],
  },
  {
    path: privatePaths.TENANTS.home,
    component: <TenantsPage />,
    layout: Layout,
    permissions: [PERMISSIONS.TENANTS_LIST],
  },
  {
    path: privatePaths.TENANTS.detail,
    component: <TenantDetailPage />,
    layout: Layout,
    permissions: [PERMISSIONS.TENANTS_VIEW],
  },
  {
    path: privatePaths.REGIONS,
    component: <RegionsPage />,
    layout: Layout,
    permissions: [PERMISSIONS.REGIONS_LIST],
  },
  {
    path: privatePaths.END_USERS,
    component: <EndUsersPage />,
    layout: Layout,
    permissions: [PERMISSIONS.SAAS_USERS_LIST],
  },
  {
    path: privatePaths.SOURCES,
    component: <SourcesPage />,
    layout: Layout,
    permissions: [PERMISSIONS.SOURCES_LIST],
  },
  {
    path: privatePaths.PLANS,
    component: <PlansPage />,
    layout: Layout,
    permissions: [PERMISSIONS.PLANS_MANAGE],
  },
  {
    path: privatePaths.PROFILE,
    component: <ProfilePage />,
    layout: Layout,
    permissions: [],
  },
];

export default privateRoutes;
